let passiveArg = null;

export const getPassiveArg = () => {
  if (passiveArg === null) {
    passiveArg = false;
    try {
      const opts = Object.defineProperty({}, "passive", {
        // eslint-disable-next-line getter-return
        get() {
          passiveArg = { passive: true };
        },
      });
      window.addEventListener("testPassive", null, opts);
      window.removeEventListener("testPassive", null, opts);
    } catch {
      // ignore
    }
  }
  return passiveArg;
};
